"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = toPascalCase;
function toPascalCase(value) {
    var pascalValue = null;

    if (value && value.length > 1) {
        pascalValue = value.charAt(0).toUpperCase() + value.substr(1).toLowerCase();
    }

    return pascalValue;
}